import React from 'react';

export const LazyPtwMyIssuePage = React.lazy(() => import('./PtwMyIssuePage'));
export const LazyPtwMyApprovalPage = React.lazy(() => import('./PtwMyApprovalPage'));
export const LazyPtwStatusPage = React.lazy(() => import('./PtwStatusPage'));
export const LazyPtwSettingPage = React.lazy(() => import('./PtwSettingPage'));
export const LazyPtwPreviewPage = React.lazy(() => import('./PtwPreviewPage'));
